export default ({ currentPage, numPages, onChange }) => (
  <div className="content-pagination">
    <div className="previous">
      <button
        type="button"
        className="btn-icon ion-ios-arrow-back"
        disabled={currentPage === 0}
        onClick={() => onChange(Math.max(0, currentPage - 1))}
      />
    </div>
    <div className="page">
      <select
        value={currentPage}
        onChange={e => onChange(parseInt(e.target.value))}
      >
        {[...new Array(numPages)].map((_, index) => (
          <option key={index} value={index}>
            {index + 1}
          </option>
        ))}
      </select>
      {` / ${numPages}`}
    </div>
    <div className="next">
      <button
        type="button"
        className="btn-icon ion-ios-arrow-forward"
        disabled={currentPage >= numPages - 1}
        onClick={() => onChange(Math.min(numPages, currentPage + 1))}
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./app/components/Pagination.js